import imageCroppie from './imageCroppie.vue'
import createAPI from '@/utils/create-api'

// eslint-disable-next-line space-before-function-paren
imageCroppie.install = function(Vue) {
  Vue.component(imageCroppie.name, imageCroppie)
  createAPI(Vue, imageCroppie, ['confirm', 'cancel', 'close'], true)
}

export default imageCroppie
